export const messages = {
  en: {
    attrSpecManage: {
      queryCondition: 'Query Condition',
      hide: 'Hide',
      more: 'More',
      specNamePlaceholder: 'Please enter spec name',
      tableNamePlaceholder: 'Please select table name',
      specPlaceholder: 'Please enter spec',
      query: 'Query',
      reset: 'Reset',
      domainPlaceholder: 'Please enter domain',
      attrConfig: 'Attribute Configuration',
      add: 'Add',
      domain: 'Domain',
      specName: 'Spec Name',
      spec: 'Spec',
      attrTable: 'Attribute Table',
      required: 'Required',
      yes: 'Yes',
      no: 'No',
      show: 'Show',
      valueType: 'Value Type',
      specType: 'Spec Type',
      queryShow: 'Query Show',
      operation: 'Operation',
      discreteValue: 'Discrete Value',
      edit: 'Edit',
      delete: 'Delete',
      buildingRoomAttr: 'Building Room Attribute',
      buildingOwnerAttr: 'Building Owner Attribute',
      buildingCommunityAttr: 'Building Community Attribute',
      machineAttr: 'Machine Attribute',
      parkingAreaAttr: 'Parking Area Attribute',
      ownerCarAttr: 'Owner Car Attribute',
      string: 'String',
      integer: 'Integer',
      amount: 'Amount',
      date: 'Date',
      time: 'Time',
      unknown: 'Unknown'
    },
    addAttrSpec: {
      add: 'Add',
      attrTable: 'Attribute Table',
      tableNamePlaceholder: 'Required, please select attribute table',
      domain: 'Domain',
      domainPlaceholder: 'Required, please enter domain',
      specName: 'Spec Name',
      specNamePlaceholder: 'Required, please enter spec name',
      specCd: 'Spec Code',
      specCdPlaceholder: 'Required, please enter spec code',
      description: 'Description',
      descriptionPlaceholder: 'Required, please enter description',
      required: 'Required',
      requiredPlaceholder: 'Required, please select if required',
      show: 'Show',
      showPlaceholder: 'Required, please select show',
      valueType: 'Value Type',
      valueTypePlaceholder: 'Required, please select value type',
      specType: 'Spec Type',
      specTypePlaceholder: 'Required, please select spec type',
      queryShow: 'Query Show',
      queryShowPlaceholder: 'Required, please select query show',
      cancel: 'Cancel',
      save: 'Save',
      tableNameRequired: 'Attribute table cannot be empty',
      domainRequired: 'Domain cannot be empty',
      specNameRequired: 'Spec name cannot be empty',
      specNameMaxLength: 'Spec name is too long',
      specCdRequired: 'Spec code cannot be empty',
      descriptionRequired: 'Description cannot be empty',
      descriptionMaxLength: 'Description cannot exceed 200 characters',
      requiredRequired: 'Required cannot be empty',
      showRequired: 'Show cannot be empty',
      valueTypeRequired: 'Value type cannot be empty',
      specTypeRequired: 'Spec type cannot be empty',
      queryShowRequired: 'Query show cannot be empty',
      saveSuccess: 'Add successfully',
      saveFailed: 'Add failed',
      buildingRoomAttr: 'Building Room Attribute',
      buildingOwnerAttr: 'Building Owner Attribute',
      buildingCommunityAttr: 'Building Community Attribute',
      machineAttr: 'Machine Attribute',
      parkingAreaAttr: 'Parking Area Attribute',
      ownerCarAttr: 'Owner Car Attribute',
      string: 'String',
      integer: 'Integer',
      amount: 'Amount'
    },
    editAttrSpec: {
      editTitle: 'Edit Attribute Configuration',
      attrTable: 'Attribute Table',
      tableNamePlaceholder: 'Required, please select attribute table',
      domain: 'Domain',
      domainPlaceholder: 'Required, please enter domain',
      specName: 'Spec Name',
      specNamePlaceholder: 'Required, please enter spec name',
      specCd: 'Spec Code',
      specCdPlaceholder: 'Required, please enter spec code',
      description: 'Description',
      descriptionPlaceholder: 'Required, please enter description',
      required: 'Required',
      requiredPlaceholder: 'Required, please select if required',
      show: 'Show',
      showPlaceholder: 'Required, please select show',
      valueType: 'Value Type',
      valueTypePlaceholder: 'Required, please select value type',
      specType: 'Spec Type',
      specTypePlaceholder: 'Required, please select spec type',
      queryShow: 'Query Show',
      queryShowPlaceholder: 'Required, please select query show',
      cancel: 'Cancel',
      save: 'Save',
      tableNameRequired: 'Attribute table cannot be empty',
      domainRequired: 'Domain cannot be empty',
      specNameRequired: 'Spec name cannot be empty',
      specNameMaxLength: 'Spec name is too long',
      specCdRequired: 'Spec code cannot be empty',
      descriptionRequired: 'Description cannot be empty',
      descriptionMaxLength: 'Description cannot exceed 200 characters',
      requiredRequired: 'Required cannot be empty',
      showRequired: 'Show cannot be empty',
      valueTypeRequired: 'Value type cannot be empty',
      specTypeRequired: 'Spec type cannot be empty',
      queryShowRequired: 'Query show cannot be empty',
      saveSuccess: 'Update successfully',
      saveFailed: 'Update failed',
      buildingRoomAttr: 'Building Room Attribute',
      buildingOwnerAttr: 'Building Owner Attribute',
      buildingCommunityAttr: 'Building Community Attribute',
      machineAttr: 'Machine Attribute',
      parkingAreaAttr: 'Parking Area Attribute',
      ownerCarAttr: 'Owner Car Attribute',
      string: 'String',
      integer: 'Integer',
      amount: 'Amount'
    },
    deleteAttrSpec: {
      confirmTitle: 'Please confirm your operation',
      confirmContent: 'Confirm to delete attribute configuration?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    attrSpecManage: {
      queryCondition: '查询条件',
      hide: '隐藏',
      more: '更多',
      specNamePlaceholder: '请输入规格名称',
      tableNamePlaceholder: '请选择表名',
      specPlaceholder: '请输入规格',
      query: '查询',
      reset: '重置',
      domainPlaceholder: '请输入域',
      attrConfig: '属性配置',
      add: '添加',
      domain: '域',
      specName: '规格名称',
      spec: '规格',
      attrTable: '属性表',
      required: '必填',
      yes: '是',
      no: '否',
      show: '展示',
      valueType: '值类型',
      specType: '规格类型',
      queryShow: '查询显示',
      operation: '操作',
      discreteValue: '离散值',
      edit: '修改',
      delete: '删除',
      buildingRoomAttr: '房屋属性',
      buildingOwnerAttr: '业主属性',
      buildingCommunityAttr: '小区属性',
      machineAttr: '设备属性',
      parkingAreaAttr: '停车场属性',
      ownerCarAttr: '车辆属性',
      string: '字符串',
      integer: '整数',
      amount: '金额',
      date: '日期',
      time: '时间',
      unknown: '未知'
    },
    addAttrSpec: {
      add: '添加',
      attrTable: '属性表',
      tableNamePlaceholder: '必填，请选择属性表',
      domain: '域',
      domainPlaceholder: '必填，请填写域',
      specName: '规格名称',
      specNamePlaceholder: '必填，请填写规格名称',
      specCd: '规格编码',
      specCdPlaceholder: '必填，请填写规格编码',
      description: '说明',
      descriptionPlaceholder: '必填，请填写说明',
      required: '是否必填',
      requiredPlaceholder: '必填，请选择是否必填',
      show: '展示',
      showPlaceholder: '必填，请选择展示',
      valueType: '值类型',
      valueTypePlaceholder: '必填，请选择值类型',
      specType: '规格类型',
      specTypePlaceholder: '必填，请选择规格类型',
      queryShow: '查询显示',
      queryShowPlaceholder: '必填，请选择查询显示',
      cancel: '取消',
      save: '保存',
      tableNameRequired: '属性表不能为空',
      domainRequired: '域不能为空',
      specNameRequired: '规格名称不能为空',
      specNameMaxLength: '规格名称太长',
      specCdRequired: '规格编码不能为空',
      descriptionRequired: '说明不能为空',
      descriptionMaxLength: '说明不能超过200位',
      requiredRequired: '是否必填不能为空',
      showRequired: '展示不能为空',
      valueTypeRequired: '值类型不能为空',
      specTypeRequired: '规格类型不能为空',
      queryShowRequired: '查询显示不能为空',
      saveSuccess: '添加成功',
      saveFailed: '添加失败',
      buildingRoomAttr: '房屋属性',
      buildingOwnerAttr: '业主属性',
      buildingCommunityAttr: '小区属性',
      machineAttr: '设备属性',
      parkingAreaAttr: '停车场属性',
      ownerCarAttr: '车辆属性',
      string: '字符串',
      integer: '整数',
      amount: '金额'
    },
    editAttrSpec: {
      editTitle: '修改属性配置',
      attrTable: '属性表',
      tableNamePlaceholder: '必填，请选择属性表',
      domain: '域',
      domainPlaceholder: '必填，请填写域',
      specName: '规格名称',
      specNamePlaceholder: '必填，请填写规格名称',
      specCd: '规格编码',
      specCdPlaceholder: '必填，请填写规格编码',
      description: '说明',
      descriptionPlaceholder: '必填，请填写说明',
      required: '是否必填',
      requiredPlaceholder: '必填，请选择是否必填',
      show: '展示',
      showPlaceholder: '必填，请选择展示',
      valueType: '值类型',
      valueTypePlaceholder: '必填，请选择值类型',
      specType: '规格类型',
      specTypePlaceholder: '必填，请选择规格类型',
      queryShow: '查询显示',
      queryShowPlaceholder: '必填，请选择查询显示',
      cancel: '取消',
      save: '保存',
      tableNameRequired: '属性表不能为空',
      domainRequired: '域不能为空',
      specNameRequired: '规格名称不能为空',
      specNameMaxLength: '规格名称太长',
      specCdRequired: '规格编码不能为空',
      descriptionRequired: '说明不能为空',
      descriptionMaxLength: '说明不能超过200位',
      requiredRequired: '是否必填不能为空',
      showRequired: '展示不能为空',
      valueTypeRequired: '值类型不能为空',
      specTypeRequired: '规格类型不能为空',
      queryShowRequired: '查询显示不能为空',
      saveSuccess: '修改成功',
      saveFailed: '修改失败',
      buildingRoomAttr: '房屋属性',
      buildingOwnerAttr: '业主属性',
      buildingCommunityAttr: '小区属性',
      machineAttr: '设备属性',
      parkingAreaAttr: '停车场属性',
      ownerCarAttr: '车辆属性',
      string: '字符串',
      integer: '整数',
      amount: '金额'
    },
    deleteAttrSpec: {
      confirmTitle: '请确认您的操作',
      confirmContent: '确定删除属性配置?',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}